import { BLOG_TOPICS, type BlogTopic } from '@mentorivo/shared';

/**
 * Blogun arayüz tarafındaki KÜÇÜK yardımcıları.
 *
 * ---------------------------------------------------------------------------
 * 🔴 Yazılar artık burada DEĞİL (13 Ağu 2026)
 * ---------------------------------------------------------------------------
 * Bu dosya bir zamanlar on iki yazının slug/konu/tarih kaydını taşıyordu,
 * başlık ve özet ise `messages/{tr,en}.json` içindeydi. İkisi de kalktı:
 * yazılar veritabanında (`blog_posts`), arayüz onları `/blog/posts` ucundan
 * okuyor (`lib/blog-api.ts`).
 *
 * Taşınma sebebi tek cümle: **yayın günü kod dağıtımına bağlı olamaz.** Bir
 * yazı eklemek için üç dosya değiştirip PM2 restart etmek gerekiyordu (yeni
 * mesaj anahtarını Turbopack sıcak almıyor); yönetimin `/admin` ekranına
 * gelmesi de bu yapıyla mümkün değildi.
 *
 * `BLOG_POST_LIVE` bayrağı da kalktı — yazı sayfası (`/blog/[slug]`) açıldı,
 * kartlar artık her zaman bağlantı.
 *
 * Konu listesi burada yeniden TANIMLANMIYOR, sözleşmeden geçiriliyor: aynı
 * listenin iki kopyası olsaydı biri değiştiğinde öteki sessizce eskirdi.
 */
export { BLOG_TOPICS };
export type { BlogTopic };

/**
 * Süzgeç sırası: "hepsi" başta, sonra sözleşmedeki konu sırası.
 *
 * `all` sözleşmede yok çünkü bir konu değil, "süzgeç kapalı" hâli — yalnızca
 * arayüzde bir düğme olarak var.
 */
export const BLOG_FILTERS = ['all', ...BLOG_TOPICS] as const;
export type BlogFilter = (typeof BLOG_FILTERS)[number];
